import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_state_switch = _resolveComponent("state-switch");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", {
    class: "sb_prioritized_cell ba-column-title ba-text ba-text-right",
    id: $props.item_id
  }, [$props.loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_state_switch, {
    key: 1,
    modelValue: $options.State,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.State = $event),
    style: {
      "margin-top": "5px",
      "--app-switch-off-bg": "#4C8EFF",
      "--app-switch-simple-bg": "#5A52AE"
    }
  }, {
    "icon-unchecked": _withCtx(() => [_createVNode(_component_app_icon, {
      icon: "gear",
      size: 10.5
    })]),
    "icon-checked": _withCtx(() => [_createVNode(_component_app_icon, {
      icon: "ai",
      size: 10.5,
      color: "#5A52AE"
    })]),
    _: 1
  }, 8, ["modelValue"])), _createVNode(_component_app_popover, {
    target: $props.item_id,
    "auto-width": "",
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($options.State ? "Automated bidding and targeting is active. Included in the budget automation algorithm" : "Not part of any automation"), 1)]),
    _: 1
  }, 8, ["target"])], 8, _hoisted_1);
}